import React from 'react';

export function CashCoinIcon() {
  return React.createElement('sl-icon', {
    name: 'cash-coin',
    style: { 
      fontSize: '16px',
      color: '#EF0BB8'
    }
  } as any);
}
